export default __webpack_public_path__ + "static/media/Group_inst13822.3325671a.svg";